import { apiEndPoint } from 'config';
import { apiConstants } from '../constants';
import { authHeader, handleResponse } from 'helpers';
import { queryFilters, queryWhere } from '../helpers/util';

export const reportService = {
  get,
};

function get(report_category, report_name, filters) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };


  if (report_category && report_name) {
    var url = apiConstants.getReport.replace(':category', report_category)
    url = url.replace(':report_name', report_name)
    if (filters) url = url.concat('', queryWhere(filters, true));
    return fetch(url, requestOptions)
      .then(handleResponse);
  } else return undefined;

}
